import ApiService from "./api";

const Machine = {
    list(params) {
        return ApiService.get('machines', {params: params});
    },
    search(params) {
        return ApiService.get('search', {params: params});
    },
    competitors(params) {
        return ApiService.get('machine_competitors', {params: params});
    },
    machineDatasComparison(params) {
        return ApiService.get('machine_data', {params: params});
    },
};

export default Machine;